import index from '../components/index.vue'
import login from '../components/login.vue'
import test from '../components/test.vue'
import listen from '../components/listen.vue'
import activation from '../components/activation.vue'
import Router from 'vue-router'
import quiz from '../components/quiz.vue'
import listenAudio from '../components/listenAudio.vue'


export default new Router({
    routes: [
        {
            path: '/index',
            name: 'index',
            component: index
        },
        {
            path: '/',
            name: 'login',
            component: login
        },
        {
            path: '/test',
            name: 'test',
            component: test
        },
        {
            path : '/listen',
            name : 'listen',
            component : listen
        },
        {
            path : '/quiz',
            name : 'quiz',
            component : quiz
        },
        {
            path: '/activation',
            name: 'activation',
            component: activation
        },
        {
            path : '/listenAudio',
            name : 'listenAudio',
            component : listenAudio
        }
    ]
})